import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';

type GuideRow = {
  title?: string;
  notes?: string;
  fileName?: string;
  downloadUrl?: string;
};

type GetGuidesResponse = {
  rows: Array<GuideRow>;
};
const BASE_URL = `${import.meta.env.VITE_BACKEND_URL}/api/guides`;

export const apiGuides = createApi({
  reducerPath: 'apiGuides',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl: BASE_URL }),
  tagTypes: ['Guides'],
  endpoints: (build) => ({
    getGuides: build.query<GetGuidesResponse, void>({
      query: () => ({
        url: `/`,
        method: 'GET'
      }),
      providesTags: ['Guides']
    }),
    syncConfluenceGuides: build.mutation({
      query: () => ({
        url: '/syncGuides',
        method: 'POST'
      }),
      invalidatesTags: ['Guides']
    })
  })
});

export const { useGetGuidesQuery, useSyncConfluenceGuidesMutation } = apiGuides;
